import { render } from "./LargeTextModel.vue?vue&type=template&id=748980f2"
import script from "./LargeTextModel.vue?vue&type=script&lang=js"
export * from "./LargeTextModel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__